<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron
                  @click="$router.push({name: 'Settings'})"/>
                {{ $t('health.notificationMessages.title') }}
              </h1>
              <div class="header-add-button">
                <router-link to="/notification-messages/edit">
                  <span
                    v-tooltip.left.top-start="$t('health.notificationMessages.new')">
                    <font-awesome-icon
                      class="header-add-button-icon"
                      :icon="icon.add"/>
                  </span>
                </router-link>
              </div>
              <alert
                v-if="alertVisible"
                :message="alertMessage"
                :type="alertType">
              </alert>
            </div>
          </grid-col>
        </grid-row>
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <table-component
              ref="messagesTable"
              :data="fetchMessages"
              :show-caption="false"
              class="datatable"
              :show-filter="true">
              <table-column show="id" label="Id" :hidden="true"></table-column>

              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    :icon="icon.edit"
                    v-on:click="onEditMessage(row)"
                    class="table-iconset-icon"/>
                </template>
              </table-column>

              <table-column
                show="messageCode"
                :label="$t('health.notificationMessages.messageCode')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>

              <table-column
                show="type"
                :label="$t('health.notificationMessages.type')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>
              <table-column
                show="typeEng"
                :label="$t('health.notificationMessages.typeEng')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>

              <table-column
                :label="this.$t('health.notificationMessages.inApp')"
                :sortable="true"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-if="row.inApp"
                    :icon="icon.check"
                    class="table-iconset-icon"/>
                </template>
              </table-column>

              <table-column
                :label="this.$t('health.notificationMessages.push')"
                :sortable="true"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-if="row.push"
                    :icon="icon.check"
                    class="table-iconset-icon"/>
                </template>
              </table-column>

            </table-component>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>

import MainLayout from '@/layouts/MainLayout.vue';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Chevron from '@/components/shared/Chevron';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableRow from '@/components/shared/table/components/TableRow';
import TableColumn from '@/components/shared/table/components/TableColumn';
import pagination from '@/components/shared/table/pagination';
import api from 'BRAND/api/notification';
import Alert from '@/components/shared/alert/Alert';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {
  faCheck, faPencilAlt
} from '@fortawesome/pro-regular-svg-icons';
import {faPlusCircle} from '@fortawesome/pro-solid-svg-icons';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';

export default {
  name: 'NotificationMessageManagement',
  components: {
    MainLayout,
    GridCol,
    GridRow,
    Chevron,
    TableComponent,
    TableRow,
    TableColumn,
    Alert,
    FontAwesomeIcon,
    OkCancelModal
  },
  data () {
    return {
      messages: [],
      icon: {
        check: faCheck,
        edit: faPencilAlt,
        add: faPlusCircle
      },
      /* Table */
      tablePageSize: 12,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      },
      /* Alert message */
      alertVisible: false,
      alertMessage: '',
      alertType: ''
    };
  },
  created () {
    this.requestData();
    const alert = this.$route.params.alert;
    if (alert !== undefined) {
      showAlert(this, this.$t(alert), 'success');
    }
  },
  watch: {
    getMessages: {
      handler: function () {
        this.$refs.messagesTable.refresh();
      }
    }
  },
  computed: {
    getBreadcrumb () {
      const self = this.$t('health.notificationMessages.title');
      return [
        {name: this.$t('menu.settings'), link: '/settings'},
        {name: self, link: '/notification-messages', disabled: true}
      ];
    },
    getMessages () {
      return this.messages;
    }
  },
  methods: {
    requestData () {
      api.getMessages(this).then(data => {
        this.messages = data;
      }).catch(() => {
        // TODO (Display error message)
      });
    },
    fetchMessages ({page, filter, sort}) {
      page = page === null || isNaN(page) ? 1 : page;
      const tablePage = pagination.createPage(
        this.getMessages,
        this.tableState,
        ['messageCode', 'type', 'typeEng'],
        this.tablePageSize,
        {page, filter, sort});
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    onEditMessage (message) {
      this.$router.push({name: 'EditNotificationMessage', params: message});
    }
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};

</script>

<style lang="scss">
@import "src/stylesheets/variables";

#header {
  display: inline-block;
  width: 100%;
  line-height: 1rem;
}
.header-title {
  float: left;
}
.header-add-button {
  float: right;
}
.header-add-button-icon {
  font-size: 3rem;
  color: $secondary;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/notifications/NotificationMessageManagement.vue